(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("TopContext", [], factory);
	else if(typeof exports === 'object')
		exports["TopContext"] = factory();
	else
		root["TopContext"] = factory();
})(this, () => {
return 